import React from 'react';
import "../../Styles/Gratitude.css";

function Gratitude() {

    return (
        <div className="gratitude">
            <div className='gratitude-container'>
                <p className='gratitude_subject'>¡Registro Exitoso!</p>
                <p className='gratitude_msn'>En un lapso de 3 días hábiles  te daremos respuesta, te pedimos que revises el correo electrónico que diste de alta para siguientes pasos.</p>

            </div>
        </div>
    )
}
export default Gratitude;